module.exports = __webpack_public_path__ + "img/active_value_bg.069b6a98.png";